import {FullClientInfoDto, FullClientInfoRs, SetNotesRq, UpdateClientInfoRq} from "@/types/clientDetails";
import {Client, ClientDto} from "@/types/client";


//Mapping from ClientRs to ClientDto
export function mapToClientDto(from: Client) : ClientDto {
    return {
        clientId: from.clientId,
        name: from.name,
        notes: from.notes,
        objectives: from.objectives,
        progress: from.progress,
        active: from.active
    }
}

function fromFullClientDto(from: FullClientInfoDto): SetNotesRq {
    return {
        notes: from.notes
    }
}

//Mapping from FullClientInfoRs to FullClientInfoDto
function toFullClientDto(from: FullClientInfoRs): FullClientInfoDto {
    return {
        clientId: from.clientId,
        name: from.name,
        color: from.color,
        notes: from.notes,
        objectives: from.objectives,
        progress: from.progress,
        active: from.active,
        activity: from.activity,
        nextAppointment: from.nextAppointment,
        allowToViewHealthData: from.allowToViewHealthData
    }
}


export function mapToSetNotesRq(from: FullClientInfoDto): SetNotesRq {
    return {
        notes: from.notes
    }
}

//Mapping from FullClientInfoRs to FullClientInfoDto
export function mapToFullClientInfoDto(from: FullClientInfoRs): FullClientInfoDto {
    return {
        clientId: from.clientId,
        name: from.name,
        color: from.color,
        notes: from.notes,
        objectives: from.objectives,
        progress: from.progress,
        active: from.active,
        activity: from.activity,
        nextAppointment: from.nextAppointment,
        allowToViewHealthData: from.allowToViewHealthData
    }
}

export function mapToUpdateClientInfoRq(from: FullClientInfoDto): UpdateClientInfoRq {
    return {
        name: from.name,
        color: from.color,
        objectives: from.objectives
    }
}
